export default "__VITE_ASSET__CiRgrOUT__"